<template>
  <el-table
    border
    :data="cmsProductItems"
    stripe
    empty-text="Aucun item"
    height="100%"
    style="width: 100%">
    <el-table-column
      prop="name"
      sortable
      resizable
      show-overflow-tooltip
      label="Reference">
      <template slot-scope="scope">
        <span class="fs-13">{{scope.row.releaseYear}}</span>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      resizable
      align="center"
      label="Image principale">
      <template slot-scope="scope">
        <span v-if="scope.row.image != null">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <slot name="content">
              <el-image
                :src="scope.row.image.thumbnailLink" >
              </el-image>
            </slot>
            <i  slot="reference" class="el-icon-success"></i>
          </el-popover>
        </span>
        <i v-else class="el-icon-error"></i>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'CmsProductItemTable',
	props: {
		cmsProductItems : {
      type : Array,
      default: ()=> [],
    },
	},
  data() {
    return {
    };
  },
  components: { },
	methods: { },
	computed: { }
}
</script>
<style>
</style>
